import { useEffect } from "react"

import { Audio, InterruptionModeAndroid, InterruptionModeIOS } from "expo-av"

let audioSetupComplete = false

// This is the primary hook for setting up the audio mode for the app.
export const useExpoAvSetup = () => {
  useEffect(() => {
    if (audioSetupComplete) {
      return
    }

    Audio.setAudioModeAsync({
      // iOS Settings:
      allowsRecordingIOS: false, // We're not using expo-av's recording capabilities
      interruptionModeIOS: InterruptionModeIOS.DoNotMix, // This prevents other audio from playing while our audio is playing
      playsInSilentModeIOS: true, // This allows audio to play even when the phone is on silent

      // Android Settings:
      playThroughEarpieceAndroid: false,
      shouldDuckAndroid: false, // This prevents other audio apps from lowering the volume of our audio
      interruptionModeAndroid: InterruptionModeAndroid.DoNotMix, // This prevents other audio from playing while our audio is playing

      // Shared Settings:
      staysActiveInBackground: false, // Setting to true allows audio to continue playing when the app is in the background
    })
      .then((mode) => {
        console.log("Audio mode set:", mode)
        audioSetupComplete = true
      })
      .catch((error) => {
        console.error("Error setting audio mode", error)
        audioSetupComplete = false
      })
  }, [])
}
